<template>
  <a
    v-ripple
    :href="routeId == clip.id ? null : '/main/clip/' + clip.id"
    class="clipItem"
    :class="{
      'clipItem-selected': hideLink,
      clipItem_active: routeId == clip.id,
    }"
    @click.prevent="goToClip()"
  >
    <img
      v-if="clip.thumbnailUrl && clip.thumbnailUrl !== '' && !imageError"
      :src="clip.thumbnailUrl"
      class="clipItem_img"
      @error="imageError = true"
    />
    <span class="clipItem_duration">
      {{ clip.duration }}
    </span>
    <no-image
      v-if="imageError || clip.thumbnailUrl === ''"
      width="100px"
      height="66px"
    />
    <div class="clipItem_detail">
      <div class="clipItem_name text-break--custom">{{ clip.clipName }}</div>
      <div class="clipItem_time">
        <span class="clipItem_date">{{
          clip.startDate | dateMs('YYYY/MM/DD', 'unix')
        }}</span>
        <span class="clipItem_hour">{{
          clip.startDate | dateMs('HH:mm:ss', 'unix')
        }}</span>
      </div>
      <div v-if="clip.event" class="clipItem_types">
        <event-label v-if="clip.event !== '$area'" :label="clip.event" />
      </div>
    </div>
  </a>
</template>

<script>
import CameraService from '@/services/CameraService';

export default {
  name: 'ClipItem',
  props: {
    clip: {
      type: Object,
      default: () => {},
    },
    hideLink: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imageError: false,
    };
  },
  computed: {
    routeId() {
      return this.$route.params.id;
    },
  },
  mounted() {},
  methods: {
    goToClip() {
      CameraService.saveClipListPosition(this.clip.offset);
      if (+this.clip.id !== +this.routeId) {
        this.$router.push({
          name: 'clip-detail',
          params: { id: this.clip.id, tag: this.$route.params.tag },
        });
      }
    },
  },
};
</script>

<style lang="scss">
.clipItem {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  padding: 9px 5px 10px 10px;
  border-top: 1px solid #ccc;
  cursor: pointer;
  & .noThumbnailImage {
    margin-right: 10px;
  }
  &_name {
    font-size: 10px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.3;
    letter-spacing: normal;
    text-align: left;
    color: #4b4b4b;
  }
  &_suspect {
    img {
      border: solid 3px #fcc800;
    }
    .clipItem_duration {
      background-color: #fcc800;
      color: #4b4b4b;
    }
  }
  &_active {
    background-color: #f3f3f3;
  }
  &_duration {
    position: absolute;
    left: 69px;
    top: 58px;
    height: 17px;
    padding: 0 5px;
    background-color: #4b4b4b;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.3;
    letter-spacing: normal;
    text-align: right;
    color: #fff;
    padding: 0 5px;
    z-index: 1;
  }
  &_play {
    position: absolute;
    font-size: 50px;
    left: 40px;
    top: 16px;
    border-radius: 10px;
    box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.06);
    color: #ffffff;
  }
  &-selected {
    &.homeClips_clip {
      cursor: default;
    }
  }
  &_img {
    height: 66px;
    width: 100px;
    flex-grow: 0;
    flex-shrink: 0;
    margin-right: 10px;
  }
  &_detail {
    flex: 1;
  }
  &_time {
    display: flex;
    flex: 1;
    color: var(--text-color);
    padding-right: 5px;
  }
  &_date {
    font-size: 12px;
    font-weight: 600;
    margin-right: 6px;
  }
  &_hour {
    font-size: 12px;
    font-weight: 600;
    flex: 1;
  }
  &_chevron {
    font-size: 12px;
    line-height: 18px;
    color: #c1c1c1;
  }
  &_types {
    display: flex;
    flex-direction: column;
    margin-top: -5px;
  }
  &_type {
    height: 19px;
    line-height: 19px;
    margin-top: 5px;
    padding: 0 5px;
    border-radius: 3px;
    background-color: var(--accent-color);
    font-size: 12px;
    font-weight: 500;
    color: var(--text-color);
    display: inline-block;
    flex-grow: 0;
    width: fit-content;
  }
  &_btns {
    display: flex;
    justify-content: space-around;
    width: 100%;
    margin-top: 9px;
    margin-bottom: 10px;
  }
  &_btn {
    width: 121px;
    .icon {
      margin-right: 5px;
      font-size: 13.3px;
    }
  }
}
</style>
